import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideBarItem } from './models';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-sidebar',
    imports: [CommonModule, RouterLinkActive, RouterLink, MatIcon],
    templateUrl: './sidebar.html',
    styleUrl: './sidebar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Sidebar {
    items = input<SideBarItem[]>([]);
    itemClicked = output<SideBarItem>();

    onSpace(event: KeyboardEvent, item: SideBarItem): void {
        event.preventDefault();
        this.itemClicked.emit(item);
    }
}
